import React from 'react';

import { Avatar } from '@poseidon/components/Avatar';
import { Communication } from '@poseidon/components/StrokeIcons';

import { isNotEmpty } from '@harmonizeai/poseidon-shared';
import { OrgAvatar } from '@poseidon/components/Avatar';
import { ContactCardContainer } from '@poseidon/components/ContactCardContainer';

type Props = {
  url: string;
  name: string;
  orgName: string;
  title: string;
};

export const DemoContactCard = ({ url, name, orgName, title }: Props) => {
  return (
    <ContactCardContainer>
      <Avatar srcs={[url]} alt={name} className="size-17.5" />

      <DemoCardBody name={name} orgName={orgName} title={title} />
    </ContactCardContainer>
  );
};

export const DemoContactCards = () => {
  const demoContacts = [
    {
      name: 'Zeus G',
      title: 'CEO',
      orgName: 'Thunderbolt Energy Solutions',
      url: 'https://cdn.useposeidon.com/zeus.webp',
    },
    {
      name: 'Athena R',
      title: 'CRO',
      orgName: 'Pallas Strategic Consulting',
      url: 'https://cdn.useposeidon.com/athena.webp',
    },
    {
      name: 'Aphrodite',
      title: 'CHRO',
      orgName: 'Venus Beauty Products',
      url: 'https://cdn.useposeidon.com/aphrodite.webp',
    },
  ];

  return demoContacts.map((contact, i) => <DemoContactCard key={i} {...contact} />);
};

type DemoCardBodyProps = {
  name: string;
  title: string;
  orgName: string;
};
function DemoCardBody({ name, title, orgName }: DemoCardBodyProps) {
  return (
    <div className="flex w-0 shrink grow flex-col justify-between text-slate-800">
      <div className="flex justify-between gap-1.5">
        <div className="flex flex-col gap-1.5">
          <div className="flex min-h-5 items-center gap-1.5 truncate text-sm font-medium">
            <span>{name}</span>
          </div>
          <div className="flex gap-1.5">
            <OrgAvatar className="size-5" />
            <div className="truncate text-xs font-lightnormal text-slate-700">
              {isNotEmpty(orgName) && <strong className="font-medium">{orgName} </strong>}
              <span>{title}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex min-h-4.5 gap-0.5 overflow-hidden">
        <div className="ml-1 flex -translate-x-1 items-center gap-0.5 text-xs opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100">
          <Communication.MessagePlusSquare className="size-4" />
          <span>Take action</span>
        </div>

        <div className="grow" />
      </div>
    </div>
  );
}
